import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import PageConstructor from '../CreatePaymentPage/PageConstructor/PageConstructor';

export default function EditProduct() {
    const navigate = useNavigate();
    const location = useLocation();

    /**
     * Restore selected page card on the previous screen.
     */
    function handleBack() {
        navigate('/pages', { state: location.state });
    }

    return (
        <PageConstructor data={location.state.editPageData} onBackClick={handleBack} />
    );
};
